import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateFirstLoginAtMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type UpdateFirstLoginAtMutation = { __typename?: 'Mutation', updateFirstLoginAt: { __typename?: 'UpdateFirstLoginAtPayload', user: { __typename?: 'AuthenticatedUser', id: string, firstLoginAt?: string | null } } };


export const UpdateFirstLoginAt = /*#__PURE__*/ gql`
    mutation UpdateFirstLoginAt {
  updateFirstLoginAt {
    user {
      id
      firstLoginAt
    }
  }
}
    ` as unknown as DocumentNode<UpdateFirstLoginAtMutation, UpdateFirstLoginAtMutationVariables>;

          

          export const useUpdateFirstLoginAtMutation = (options?:MutationHookOptions<UpdateFirstLoginAtMutation, UpdateFirstLoginAtMutationVariables>) => useMutation(UpdateFirstLoginAt, options);
          

          export type UpdateFirstLoginAtMutationOptions = MutationHookOptions<UpdateFirstLoginAtMutation, UpdateFirstLoginAtMutationVariables>;

          

          export type UpdateFirstLoginAtMutationResult = ReturnType<typeof useUpdateFirstLoginAtMutation>[1];

          
